import { useCallback } from 'react';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { AgencyTypeGlobal, globalAttributes } from '../global-attributes';
import { useQueueStore } from '../../queues/context/use-queue-store';
import { useApplicationType } from './use-application-type';

export function useIsAgencyTypeGlobalAttributeIdConsidered(): (
    agencyTypeGlobal: AgencyTypeGlobal
) => boolean {
    const { userAgencyTypeGlobalAttrId } = useBootstrapState();
    const { isFirstResponder } = useApplicationType();
    const queueStore = useQueueStore();
    const { queueClasses } = queueStore.workspacePanel.queue;

    const getQueueClassFromAgencyTypeGlobal = useCallback((agencyTypeGlobal: AgencyTypeGlobal) => {
        switch (agencyTypeGlobal) {
            case globalAttributes.agencyTypeGlobal.POLICE:
                return 'POLICE';
            case globalAttributes.agencyTypeGlobal.EMS:
                return 'MEDICAL';
            default:
                return 'FIRE';
        }
    }, []);

    const isUserAgencyTypeGlobalAttrIdEmsOrFire =
        userAgencyTypeGlobalAttrId === globalAttributes.agencyTypeGlobal.EMS ||
        userAgencyTypeGlobalAttrId === globalAttributes.agencyTypeGlobal.FIRE;

    const isAgencyTypeGlobalAttrIdConsideredForFirstResponder = useCallback(
        (agencyTypeGlobal: AgencyTypeGlobal) =>
            !isUserAgencyTypeGlobalAttrIdEmsOrFire ||
            agencyTypeGlobal !== globalAttributes.agencyTypeGlobal.POLICE,
        [isUserAgencyTypeGlobalAttrIdEmsOrFire]
    );

    return useCallback(
        (agencyTypeGlobal: AgencyTypeGlobal) =>
            isFirstResponder
                ? isAgencyTypeGlobalAttrIdConsideredForFirstResponder(agencyTypeGlobal)
                : queueClasses.includes(getQueueClassFromAgencyTypeGlobal(agencyTypeGlobal)),
        [
            getQueueClassFromAgencyTypeGlobal,
            isAgencyTypeGlobalAttrIdConsideredForFirstResponder,
            isFirstResponder,
            queueClasses,
        ]
    );
}
